import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, Clock } from 'lucide-react';
import { articles } from '../data/articles';
export function ArticlesPage() {
  return <main className="flex-grow pt-24" data-id="element-398">
      <div className="bg-midnight text-ivory py-24 text-center relative overflow-hidden" data-id="element-399">
        <div className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-400" />

        <div className="relative z-10" data-id="element-401">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-402">
            Resources
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-6" data-id="element-403">
            Our{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-404">
              Articles
            </span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-ivory/70 font-medium max-w-2xl mx-auto px-6" data-id="element-405">
            Teachings, reflections, and words of encouragement.
          </motion.p>
        </div>
      </div>

      <section className="py-32 bg-ivory text-midnight" data-id="element-406">
        <div className="max-w-7xl mx-auto px-6" data-id="element-407">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-408">
            {articles.map((article, idx) => <motion.div key={article.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-409">
                <Link to={`/articles/${article.slug}`} className="group block bg-white p-8 rounded-[2rem] border-2 border-midnight/5 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 h-full flex flex-col" data-id="element-410">
                  <div className="flex items-center gap-2 px-3 py-1 bg-gold/10 text-gold rounded-full text-xs font-bold tracking-widest uppercase mb-6 w-fit" data-id="element-411">
                    <BookOpen className="w-3 h-3" data-id="element-412" />
                    <span data-id="element-413">Article</span>
                  </div>

                  <h3 className="text-2xl font-display font-bold text-midnight leading-tight mb-4 group-hover:text-gold transition-colors" data-id="element-414">
                    {article.title}
                  </h3>

                  <p className="text-charcoal/70 font-medium leading-relaxed text-base mb-8 flex-grow" data-id="element-415">
                    {article.excerpt}
                  </p>

                  <div className="flex items-center justify-between pt-6 border-t-2 border-midnight/5 text-sm font-bold text-charcoal/50 uppercase tracking-wider" data-id="element-416">
                    <span className="flex items-center gap-2" data-id="element-417">
                      <Clock className="w-4 h-4" data-id="element-418" />
                      {article.readTime}
                    </span>
                    <div className="w-10 h-10 rounded-full bg-midnight/5 flex items-center justify-center group-hover:bg-midnight group-hover:text-ivory transition-colors text-midnight" data-id="element-419">
                      <ArrowRight className="w-4 h-4" data-id="element-420" />
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>

          {articles.length === 0 && <div className="text-center py-20 bg-white rounded-[2rem] border-2 border-midnight/5" data-id="element-421">
              <p className="text-xl font-medium text-charcoal/60" data-id="element-422">
                New articles coming soon.
              </p>
            </div>}
        </div>
      </section>
    </main>;
}